import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const BrickmouldSize = ({ value, onChange, label = 'Size', brickmouldTypeValue }) => {
    const [selectedBrickmouldSize, setSelectedBrickmouldSize] = useState(value || "");
    const [visibleOptions, setVisibleOptions] = useState({
        "1": true,
        "1 5/8": true,
        "2": true,
    });

    useEffect(() => {
        if (brickmouldTypeValue === "Standard") {
            setVisibleOptions((prevState) => ({
                ...prevState,
                "1": false, // Hide the '1"' option for "Standard"
            }));
        } else {
            setVisibleOptions((prevState) => ({
                ...prevState,
                "1": true, // Show the '1"' option for other types
            }));
        }
    }, [brickmouldTypeValue]);

    const handleBrickmouldSizeChange = (e) => {
        const newValue = e.target.value;
        setSelectedBrickmouldSize(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="BrickmouldSize">{label}</label>
            <select style={{ display: "none" }}
                id="BrickmouldSize"
                value={selectedBrickmouldSize}
                onChange={handleBrickmouldSizeChange}
            >
                <option value="" disabled hidden>Select an option</option>
                {visibleOptions["1"] && (
                    <option value='1"'>{selectedBrickmouldSize === '1"' ? '1" ✔' : '1"'}</option>
                )}
                {visibleOptions["1 5/8"] && (
                    <option value='1 5/8"'>{selectedBrickmouldSize === '1 5/8"' ? '1 5/8" ✔' : '1 5/8"'}</option>
                )}
                {visibleOptions["2"] && (
                    <option value='2"'>{selectedBrickmouldSize === '2"' ? '2" ✔' : '2"'}</option>
                )}
            </select>
        </div>
    );
};

export default BrickmouldSize;
